// React Hooks:
import React, { useState } from "react";
// Redux Toolkit Hooks:
import { useAppDispatch } from "../../../../app/hooks";
// Redux Toolkit Actions & State:
import { uploadFileOpenAction } from "./upload-file/uploadFileSlice";
import { createFolderOpenAction } from "./create-folder/createFolderSlice";
// MUI Components:
import {
  Container,
  Box,
  Button,
  SvgIcon,
  Typography,
  useTheme,
} from "@mui/material";
// Components:
import CreateFolder from "./create-folder/CreateFolder";
import UploadFile from "./upload-file/UploadFile";
import ResponsiveUploadAndCreate from "./responsive-upload-and-create/ResponsiveUploadAndCreate";

// Icones:
import { ReactComponent as UploadIcon } from "../../../../assets/icons/upload-icon.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus-icon.svg";

const UploadAndCreate = () => {
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const [popoverCreateFolder, setPopoverCreateFolder] =
    useState<HTMLButtonElement | null>(null);

  const handleCreateFolderClick = (event: any) => {
    setPopoverCreateFolder(event.currentTarget);
  };
  const handleCloseCreateFolder = () => {
    setPopoverCreateFolder(null);
  };

  const openPopover = Boolean(popoverCreateFolder);
  const id = openPopover ? "ignoreDisableTouch" : undefined;

  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          p: { xs: 0 },
          [theme.breakpoints.down("sm")]: {
            display: "none",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "24px",
            color: (theme) => theme.palette.text.secondary,
            mb: "8px",
            [theme.breakpoints.down("md")]: {
              fontSize: "20px",
              mb: "6px",
            },
          }}
        >
          Home
        </Typography>

        <Box>
          <Button
            id="ignoreDisableTouch"
            variant="contained"
            color="blue"
            fullWidth
            type="submit"
            sx={{
              width: "170px",
              height: "45px",
              fontSize: "18px",
              borderRadius: "5px",
              textTransform: "none",
              lineHeight: "0px",
              padding: "12px",
              mr: "8px",
              [theme.breakpoints.down("md")]: {
                width: "155px",
                height: "38px",
                fontSize: "16px",
              },
              [theme.breakpoints.down(680)]: {
                width: "calc(50% - 4px)",
              },
            }}
            onClick={() => dispatch(uploadFileOpenAction())}
          >
            <SvgIcon
              component={UploadIcon}
              inheritViewBox
              sx={{
                width: "auto",
                height: "18px",
                color: "inherit",
                cursor: "pointer",
                mr: "4px",
                [theme.breakpoints.down("md")]: {
                  height: "16px",
                },
              }}
            />
            Upload File
          </Button>

          <Button
            id="ignoreDisableTouch"
            variant="contained"
            color="tertiary"
            fullWidth
            type="submit"
            sx={{
              width: "170px",
              height: "45px",
              fontSize: "18px",
              borderRadius: "5px",
              textTransform: "none",
              lineHeight: "0px",
              padding: "12px",
              [theme.breakpoints.down("md")]: {
                width: "155px",
                height: "38px",
                fontSize: "16px",
              },
              [theme.breakpoints.down(680)]: {
                width: "calc(50% - 4px)",
              },
            }}
            onClick={(event) => {
              handleCreateFolderClick(event);
              dispatch(createFolderOpenAction());
            }}
          >
            <SvgIcon
              component={PlusIcon}
              inheritViewBox
              sx={{
                width: "16px",
                height: "16px",
                color: "inherit",
                stroke: (theme) => theme.palette.tertiary?.contrastText,
                cursor: "pointer",
                mr: "4px",
                [theme.breakpoints.down("md")]: {
                  height: "16px",
                },
              }}
            />
            Create Folder
          </Button>

          <CreateFolder
            id={id}
            openPopover={openPopover}
            popoverCreateFolder={popoverCreateFolder}
            handleCloseCreateFolder={handleCloseCreateFolder}
          />
        </Box>

        <UploadFile />
      </Container>

      <ResponsiveUploadAndCreate
        handleCreateFolderClick={handleCreateFolderClick}
      />
    </>
  );
};

export default UploadAndCreate;
